<template>
    <form-row title="Lender">
        <div class="flex-1 -mt-2">
            <div class="flex flex-col sm:flex-row">
                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[buyer_lender][name]"
                        :value="contact.name"
                        label="Name"
                        placeholder="Name"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[buyer_lender][email]"
                        :value="contact.email"
                        label="Email"
                        placeholder="Email"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[buyer_lender][phone]"
                        :value="contact.phone"
                        label="Phone"
                        placeholder="Phone"
                        :read_only="read_only"
                    />
                </div>
            </div>

            <div class="mt-3">
                <input-text
                    label="Company"
                    name="contacts[buyer_lender][company]"
                    :value="contact.company"
                    placeholder="Company"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-3">
                <input-text
                    label="Lender #"
                    name="contacts[buyer_lender][external_id]"
                    :value="contact.external_id"
                    placeholder="Lender #"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-3">
                <input-text
                    label="Address"
                    name="contacts[buyer_lender][address_1]"
                    :value="contact.address_1"
                    placeholder="Address"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-3">
                <input-text
                    name="contacts[buyer_lender][address_2]"
                    :value="contact.address_2"
                    placeholder="Address 2"
                    :read_only="read_only"
                />
            </div>

            <div class="flex flex-col sm:flex-row sm:mt-3">
                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-text
                        name="contacts[buyer_lender][city]"
                        :value="contact.city"
                        placeholder="City"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-select-states
                        name="contacts[buyer_lender][state]"
                        no_selection="Select State"
                        :value="contact.state"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-text
                        name="contacts[buyer_lender][zip]"
                        :value="contact.zip"
                        placeholder="Zip"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        contact: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
